// extracted by mini-css-extract-plugin
export default {"footer":"GlobalFooter_footer__po5wX","text":"GlobalFooter_text__HpSjv","author":"GlobalFooter_author__QYNUl"};